import React from 'react';
import { string, oneOf, bool } from 'prop-types';
import cx from 'classnames';

import hamburger from '../../assets/icons/hamburger.svg';
import arrowRight from '../../assets/icons/right-arrow.svg';
import arrowLeft from '../../assets/icons/left-arrow.svg';
import instagram from '../../assets/icons/instagram.svg';
import instagram2 from '../../assets/icons/instagram-2.svg';
import facebook from '../../assets/icons/facebook.svg';
import phone from '../../assets/icons/phone.svg';
import mail from '../../assets/icons/mail.svg';
import location from '../../assets/icons/location.svg';
import like from '../../assets/icons/like.svg';

import spinner from '../../assets/animations/spinner.svg';

const propTypes = {
  alt: string,
  name: string,
  size: oneOf(['small', 'medium', 'large']),
  src: string,
  isFluid: bool,
};

const CLASS_ROOT = 'icon';

const Icon = ({ className, name, size, alt, src, isFluid, ...other }) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${size}`]: size,
      [`${CLASS_ROOT}--${name}`]: name,
      [`${CLASS_ROOT}--fluid`]: src || isFluid,
    },
    className,
  );

  const getIcon = iconName => {
    if (name) {
      switch (iconName) {
        case 'hamburger':
          return hamburger.id;
        case 'right-arrow':
          return arrowRight.id;
        case 'left-arrow':
          return arrowLeft.id;
        case 'instagram':
          return instagram.id;
        case 'instagram-2':
          return instagram2.id;
        case 'facebook':
          return facebook.id;
        case 'phone':
          return phone.id;
        case 'mail':
          return mail.id;
        case 'location':
          return location.id;
        case 'like':
          return like.id;
        case 'spinner':
          return spinner.id;
        default:
          return '';
      }
    }
    return src;
  };

  return (
    <svg className={classes} {...other}>
      <use xlinkHref={`#${getIcon(name)}`} />
    </svg>
  );
};

Icon.propTypes = propTypes;

export default Icon;
